import { ADVISOR_TEAM_UPGRADE_PRODUCT_ID } from '@src/components/sco/Advisors/model/access'

export type DirectMessageTarget = {
  isAdvisor?: boolean | null
  isToolUser?: boolean | null
  slug?: string | null
}

export type DirectMessageCaller = {
  isAdmin?: boolean | null
  isAdvisor?: boolean | null
  contentPermissions?: { canAccessAdvisorTeam?: boolean | null } | null
} | null

/**
 * Startups.com team advisors (`users.isAdvisor`). Marketplace AdvisorProfile
 * users are not this flag. Tool companions (Wil) are excluded even if flagged.
 */
export const isTeamAdvisorMessagingTarget = (user?: DirectMessageTarget | null): boolean => {
  if (!user?.isAdvisor) {
    return false
  }
  if (user.isToolUser) {
    return false
  }
  if (user.slug?.startsWith('startupscom-tool-')) {
    return false
  }
  return true
}

export const canUnlockTeamAdvisorMessaging = (currentUser?: DirectMessageCaller): boolean => {
  return !!(
    currentUser?.isAdmin ||
    currentUser?.isAdvisor ||
    currentUser?.contentPermissions?.canAccessAdvisorTeam
  )
}

export const TEAM_ADVISOR_DM_PAYWALL = {
  contentPermission: 'canAccessAdvisorTeam' as const,
  upgradeProductId: ADVISOR_TEAM_UPGRADE_PRODUCT_ID,
  title: 'Upgrade to message the Startups.com advisor team.',
}

export const paywallPropsForMessagingTarget = (
  target: DirectMessageTarget | null | undefined,
  currentUser?: DirectMessageCaller
) => {
  if (!isTeamAdvisorMessagingTarget(target)) {
    return null
  }
  return {
    ...TEAM_ADVISOR_DM_PAYWALL,
    isUnlocked: canUnlockTeamAdvisorMessaging(currentUser),
  }
}
